import { ErrorView } from './ErrorView';
import { NetworkErrorModal } from '@src/components/modals/NetworkErrorModal';
import { useServerStatusStore } from '@src/utils/errorHandling/ServerStatusStore';

export default function GlobalErrorHandler() {
  const serverIsDown = useServerStatusStore((s) => s.serverIsDown);

  if (serverIsDown) {
    return <NetworkErrorModal />;
  } else {
    return <ErrorView />;
  }
}
